import React, {useState, useEffect, useRef} from 'react'
import moment from "moment"
import { Box ,TextField, Button} from '@mui/material';
import { DatePicker,LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {getNumDaysFromDateRange, getNumMonths, getNumWeeks,calcWeeksInMonth} from "../../app/util"
import './customCalendar.css';
import Week from './Week';
import { DateRangePicker } from 'react-date-range';
function CustomCalendar({modifyCalendarDates,asOfDate, changeDateRange, currentCalendarDates}) {
    const dateRangeComp = useRef({date_from:moment(asOfDate).format("YYYY-MM-DD"),
     date_until:moment().add(89,"days").format("YYYY-MM-DD")});
    
    const [dateDisplay, setDateDisplay] = useState({...dateRangeComp.current});
    const [range, setRange] = useState({...dateRangeComp.current})
    const compCalendarDates = useRef([]);
    const [calendarDates, setCalendarDates] = useState([]);
    const [dateRangePickerVisiblity, setDateRangePickerVisiblity] = useState(false);
    const weekDays = ["Sun", "Mon" , "Tue", "Wed", "Thu", "Fri", "Sat"];
    const [selectedWeekDays, setSelectedWeekDays] = useState([]);
    const [selectedWeekNumbers, setSelectedWeekNumbers] = useState([]);
    const [currentMonth, setCurrentMonth] = useState(moment(asOfDate).format("MM"));
    useEffect(() => {
        let isSubscribed = true;
        const numDates = getNumDaysFromDateRange(dateRangeComp.current);
        const calendarDates= [];
        for (let index = 0; index < numDates ; index++) {
            calendarDates.push({
                date:moment(dateRangeComp.current.date_from).add(index,'days').format("YYYY-MM-DD"),
            })
            
        }
        compCalendarDates.current = calendarDates;
        setCalendarDates(prev=>{
            return calendarDates;
        })
       
        return () => {
            isSubscribed =false;
        }
    }, [dateDisplay])
    useEffect(()=>{
        setCalendarDates(prev=>{
            return currentCalendarDates
        })
    },[currentCalendarDates])
    const updateCalendarDates =(curr_date,type, active)=>{
        if(type === "date"){
            compCalendarDates.current = compCalendarDates.current.map(item=>{
                if(curr_date === item.date){
                    item.active = active;
                   
                }
                return item;
            })
            if (active === false){
                const weekday = moment(curr_date).format("ddd");
                const index = selectedWeekDays.indexOf(weekday);
                if (index > -1) { // only splice array when item is found
                    selectedWeekDays.splice(index, 1);
                }
                setSelectedWeekDays(prev=>[...selectedWeekDays])
                let weekStart = moment(curr_date).startOf("week");
                const weekNum = moment(weekStart).week();
                const weekIndex = selectedWeekNumbers.indexOf(weekNum)
                if (weekIndex > -1) { // only splice array when item is found
                    selectedWeekNumbers.splice(weekIndex, 1);
                }
                setSelectedWeekNumbers(prev=> [...selectedWeekNumbers]);
            }
            setCalendarDates(prev=>{
                return [...compCalendarDates.current];
            })
        }
        if(type === "week"){
            let weekStart = curr_date;
            let weekEnd = moment(curr_date).endOf("week");
            compCalendarDates.current = compCalendarDates.current.map(item=>{
                if(moment(item.date).isBetween(weekStart, weekEnd,"day","[]")){
                    item.active = active;
                   
                }
                return item;
            })
            setCalendarDates(prev=>{
                return [...compCalendarDates.current];
            })
            const weekNum = moment(weekStart).week();
            let index = selectedWeekNumbers.indexOf(weekNum)
            if(active === true){
                if(index<0){
                    selectedWeekNumbers.push(weekNum);
                }
            }
            if(active === false){
                if(index>-1){
                    selectedWeekNumbers.splice(index, 1)
                }
            }
            setSelectedWeekNumbers(prev=> [...selectedWeekNumbers]);
           
        }
        if(type === "dayOfweek"){
          
            compCalendarDates.current = compCalendarDates.current.map(item=>{
                if(moment(item.date).format("ddd") === curr_date){
                    item.active = active;
                }
                return item;
            })
            setCalendarDates(prev=>{
                return [...compCalendarDates.current];
            })
        }
        modifyCalendarDates(compCalendarDates.current)
       
    }
   
   
    const calendarSelection= ()=>{
        // const numWeeks = getNumWeeks(dateRangeComp);
        const numMonths = getNumMonths({
            date_from:moment(dateRangeComp.current.date_from).startOf("month").format("YYYY-MM-DD"),
             date_until:moment(dateRangeComp.current.date_until).endOf("month").format("YYYY-MM-DD")
        });
        const months=[];
        let weekCount =moment(dateRangeComp.current.date_from).week();
        let numWeeks=0;
        let weekslist = [];
        let calendar=[];
        for (let monthCount = 0; monthCount < numMonths; monthCount++) {
            const weeks=[];
            let currMonth = moment(dateRangeComp.current.date_from).add(monthCount, "months").startOf("month").format("YYYY-MM-DD");
            let startDate = moment(dateRangeComp.current.date_from).startOf("month").add(monthCount, "months").startOf("week").format("YYYY-MM-DD");
            let endDate = moment(dateRangeComp.current.date_from).add(monthCount, "months").endOf("month").endOf("week").format("YYYY-MM-DD");
            let  weeksInMonth = getNumWeeks({date_from:startDate, date_until:endDate});
        
            for (let j = 0; j < weeksInMonth; j++) {
                const currentWeek = moment(startDate).add(j, "weeks")
                .startOf("week").format("YYYY-MM-DD");
                if(moment(currentWeek).isAfter(dateRangeComp.current.date_until)){
                    break;
                }
                if(moment(currentWeek).isBefore(moment(dateRangeComp.current.date_from).startOf("week"))){
                    continue;
                }
                weekCount= moment(startDate).add(j, "weeks").week();
                const activeWeek = (selectedWeekNumbers.indexOf(weekCount)>-1) ? true:false
                weeks.push(<Week currMonth={currMonth} 
                    currentWeek={currentWeek} 
                    weekCount={weekCount}
                    dateRange={dateRangeComp.current} calendarDates={calendarDates}
                    activeWeek={activeWeek}
                    updateCalendarDates={updateCalendarDates} />);
                
            }
            months.push(<div className="calendar-month">
                    <div className='calendar-month-title'>{moment(currMonth).format("MMMM YYYY")}</div>
                    {weeks}             
            </div>);
        }
        return (<>{months}</>)
    }
    const changedateRangeComp = (value , type)=>{
           
           
            if(type === "date_from"){
                
              
                setDateDisplay(prev=>{
                    return {...prev,date_from:value}
                })
                if(moment(value).isValid() && value.length  === 10 &&
                moment(value).isSameOrAfter(asOfDate) && 
                moment( dateRangeComp.current.date_until).diff( value, 'years') < 2 &&
                moment( dateRangeComp.current.date_until).diff( value, 'days') >= 0 ){
                    dateRangeComp.current.date_from = value;
                    changeDateRange(dateRangeComp.current)
                }
               
            }
            else if(type === "date_until"){
                
                
                setDateDisplay(prev=>{
                    return {...prev,date_until:value}
                })
                if(moment(value).isValid() && 
                    value.length  === 10 &&
                    moment(value).diff( dateRangeComp.current.date_from, 'years') < 2 && 
                    moment(value).diff( dateRangeComp.current.date_from, 'days') >= 0
                ){
                    dateRangeComp.current.date_until = value;
                    
                    changeDateRange(dateRangeComp.current)
                }
                

            }else if(type==="range"){
                changeDateRange(dateRangeComp.current)
            }


           

    }
    const dateRangePicker =(                                
        <div   className={
            dateRangePickerVisiblity ? "date-range-picker-container" : "date-range-picker-container-false"
        }>
            <DateRangePicker
                showSelectionPreview={true}
                moveRangeOnFirstSelection={false}
                months={2}
                direction="horizontal"
                ranges={[
                    {
                        startDate: new Date(range.date_from),
                        endDate: new Date(range.date_until),
                        key: 'selection',
                    },
                ]}
                minDate={new Date()} // disabled previous date from current date
                onChange={(ranges) => {
                    // Update arrival and departure dates based on user selection
                    console.log("addEventStartDate", moment(ranges.selection.startDate).format("YYYY-MM-DD"));
                    console.log("addEventEndDate", moment(ranges.selection.endDate).format("YYYY-MM-DD"));
                    setRange({
                        date_from:ranges.selection.startDate,
                        date_until:ranges.selection.endDate,
                    })
                    dateRangeComp.current.date_from = moment(ranges.selection.startDate).format("YYYY-MM-DD");
                    dateRangeComp.current.date_until = moment(ranges.selection.endDate).format("YYYY-MM-DD");
                }}
            />
            <Box sx={{ background: "#FFF" }} className="datepicker-done-btn"><Button onClick={()=>{
                setDateDisplay({
                    date_from:dateRangeComp.current.date_from,
                    date_until:dateRangeComp.current.date_until
                })
                changedateRangeComp(dateRangeComp.current, 'range')
                setDateRangePickerVisiblity(false);

            }}>Done</Button></Box>
        </div>
  )
    return (
        <div className="custom-calendar-container">
            <header className="calendar-header">
                <div className="calendar-current-date"  onClick={()=>{
                            setDateRangePickerVisiblity(true);
                        }}>
                    <TextField
                        className="date-picker"
                        variant="standard"                        
                        size="small"
                        id="date-from"
                        onClick={()=>{
                            setDateRangePickerVisiblity(true);
                        }}
                        onChange={e=>{
                            changedateRangeComp(e.target.value, "date_from")
                        }} value={dateDisplay.date_from} 
                    />
                    {'-'}
                    <TextField
                        variant="standard"
                        size="small"
                        id="date-until"
                        className='date-picker'
                        onClick={()=>{
                            setDateRangePickerVisiblity(true);
                        }}
                        onChange={e=>{
                            console.log("debug")
                            changedateRangeComp(e.target.value, "date_until")
                        }}  
                        value={dateDisplay.date_until} 
                    />
                </div>
                {dateRangePicker}
            </header>
            <ul className="calendar-weekdays calendar-week">
                {weekDays.map((item,index)=>{
                    let activeClass = (selectedWeekDays.indexOf(item)> -1) ? "active": "";

                    return(<li class={"week-day-item " + activeClass} onClick={()=>{
                        let findIndex = selectedWeekDays.indexOf(item)
                        if(findIndex <0){
                            selectedWeekDays.push(item);
                            updateCalendarDates(item,"dayOfweek", true);
                        }else {
                            selectedWeekDays.splice(findIndex, 1);
                            updateCalendarDates(item,"dayOfweek", false);
                        }
                        setSelectedWeekDays(prev=> selectedWeekDays);
                        
                    }} key={index} ><div>{item}</div></li>)
                })}
            </ul>
            <div className="calendar-selection">
                {calendarSelection()}
            </div>
        </div>
    )
}

export default CustomCalendar
